import { useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AdminSidebar from "./admin/AdminSidebar";
import DashboardOverview from "./admin/DashboardOverview";
import CoachAccountsManagement from "./admin/CoachAccountsManagement";
import TrainingManagement from "./admin/TrainingManagement";
import ApplicationsManagement from "./admin/ApplicationsManagement";

const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-[#05050A] flex" data-testid="admin-dashboard">
      <AdminSidebar
        sidebarOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        user={user}
        onLogout={handleLogout}
        isActive={isActive}
      />

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className="flex-1 min-h-screen">
        {/* Top bar */}
        <header className="bg-[#0F0F16] border-b border-white/10 p-4 lg:hidden">
          <button onClick={() => setSidebarOpen(true)} className="p-2" data-testid="open-sidebar-button">
            <Menu className="w-6 h-6" />
          </button>
        </header>

        {/* Content */}
        <div className="admin-content p-6 lg:p-8">
          <Routes>
            <Route path="dashboard" element={<DashboardOverview />} />
            <Route path="coach-accounts" element={<CoachAccountsManagement />} />
            <Route path="training" element={<TrainingManagement />} />
            <Route path="applications" element={<ApplicationsManagement />} />
            <Route path="*" element={<DashboardOverview />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
